import styled from 'styled-components';
import { ISelect2Props } from '../../../types/formTypes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectWrapper = styled.div<Pick<ISelect2Props, 'width' | 'darkMode' | 'error'>>`
  position: relative;
  width: auto;
  max-width: ${({ width }) => {
    if (!width) return 'none';
    return width + 'px';
  }};

  .chord-select__control {
    min-height: 48px;
    border-radius: 0;
    transition: none;
    border: ${({ error }) => {
      if (error !== undefined) return `1px solid var(--base-color-errorstate)`;
      return `1px solid var(--base-color-darkgrey)`;
    }};
    &:hover {
      border-color: ${({ error }) => {
        if (error !== undefined) return `var(--base-color-errorstate)`;
        return `var(--base-color-darkgrey)`;
      }};
    }
  }
  .chord-select__control--is-focused {
    border-color: var(--base-color-darkgrey);
    box-shadow: ${({ darkMode }) => {
      if (darkMode) return `0 0 0 4px var(--base-color-lemonchiffon)`;
      return `0 0 0 3px var(--base-color-lapislazuli)`;
    }};
  }
  .chord-select__control--menu-is-open {
    .chord-select__indicator {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .chord-select__indicator {
    font-size: 25px;
    padding: 0;
    margin-right: 12px;
    color: var(--base-color-black);
    svg {
      height: 1em;
      width: 1em;
      color: inherit;
      path {
        fill: currentColor;
        color: inherit;
      }
    }
  }
  .chord-select__single-value,
  .chord-select__placeholder {
    margin-left: 0;
    margin-right: 0;
    font-family: var(--font-family-altHeader);
    font-feature-settings: var(--font-feature-settings-altHeader);
    font-size: var(--font-size-altHeader-6);
    font-weight: var(--font-weight-altHeader-6);
    letter-spacing: var(--letter-spacing-altHeader-6);
    line-height: var(--line-height-altHeader-6);
    text-transform: var(--text-transform-altHeader);
  }
  .chord-select__placeholder {
    color: var(--base-color-darkgrey);
  }
  .chord-select__single-value {
    color: var(--base-color-black);
  }
  .chord-select__value-container {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 1px;
    padding-bottom: 0px;
  }
  .chord-select--is-disabled {
    .chord-select__control {
      border: 1px solid var(--base-color-lightgrey);
      background: var(--base-color-lightgrey);
    }
    .chord-select__indicator,
    .chord-select__single-value {
      color: var(--base-color-darkgrey);
    }
  }
  .chord-select__menu {
    margin-top: -1px;
    box-shadow: none;
    border-radius: 0;
    border: 1px solid var(--base-color-darkgrey);
    background: var(--base-color-lightgrey);
  }
  .chord-select__menu-list {
    padding-top: 0;
    padding-bottom: 0;
  }
  .chord-select__option {
    padding: 10px 20px;
    font-family: var(--font-family-altHeader);
    font-feature-settings: var(--font-feature-settings-altHeader);
    font-size: var(--font-size-altHeader-6);
    font-weight: var(--font-weight-altHeader-6);
    letter-spacing: var(--letter-spacing-altHeader-6);
    line-height: var(--line-height-altHeader-6);
    text-transform: var(--text-transform-altHeader);
    color: var(--base-color-black);
    &:active,
    &.chord-select__option--is-focused {
      background: var(--base-color-midgrey);
    }
  }
  .chord-select__option--is-selected {
    color: var(--base-color-black);
    background: none;
  }
  .chord-select__input-container {
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;
    font-family: var(--font-family-altHeader);
    font-feature-settings: var(--font-feature-settings-altHeader);
    font-size: var(--font-size-altHeader-6);
    font-weight: var(--font-weight-altHeader-6);
    letter-spacing: var(--letter-spacing-altHeader-6);
    line-height: var(--line-height-altHeader-6);
    text-transform: var(--text-transform-altHeader);
    color: var(--base-color-black);
  }
  .chord-select__menu-notice {
    padding: 20px 20px;
    font-family: var(--font-family-body);
    font-feature-settings: var(--font-feature-settings-body);
    font-size: var(--font-size-body-1);
    font-weight: var(--font-weight-body-1);
    letter-spacing: var(--letter-spacing-body-1);
    line-height: var(--line-height-body-1);
    text-transform: var(--text-transform-body);
    color: var(--base-color-black);
    text-align: left;
  }
  .chord-select__menu-notice--loading {
    font-style: italic;
  }
`;

export const TextLabel = styled.div<Pick<ISelect2Props, 'darkMode'>>`
  margin: 0 0 20px;
  color: ${({ darkMode }) => {
    if (darkMode) return `var(--base-color-white)`;
    return `var(--base-color-black)`;
  }};
`;

export const ErrorLabel = styled.div<Pick<ISelect2Props, 'darkMode'>>`
  margin: 20px 0 0;
  color: ${({ darkMode }) => {
    if (darkMode) return `var(--base-color-white)`;
    return `var(--base-color-errorstate)`;
  }};
`;
